
import SecretInput from './secretinput'

export default SecretInput;